import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { AboutComponent } from './about/about.component';
import { ContactComponent } from './contact/contact.component';
import { PrivacyPolicyComponent } from './legal/privacy-policy/privacy-policy.component';
import { RodoComponent } from './legal/rodo/rodo.component';

export const routes: Routes = [
  {
    path: '',
    component: HomeComponent
    //canActivate: [NavPanelGuardService, NotAuthGuardService]
  },  // Strona główna
  {
    path: 'about',
    component: AboutComponent
  },  // Strona "O nas"
  {
    path: 'kontakt',
    component: ContactComponent
  },  // Strona "Kontakt"
  {
    path: 'polityka-prywatnosci',
    component: PrivacyPolicyComponent
  },
  {
    path: 'rodo',
    component: RodoComponent
  },
  {path: '**', redirectTo: ''}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})

export class AppRoutingModule { }
